<template>
  <div class="history-wrap">
    <div class="history_title main clearfix">
      <div class="left title_left">
        <p class="left text">当前页面为<span>{{ data.createdAt }}</span>历史直播</p>
        <p class="right order"><nuxt-link :to="`/room/history-list/${data.teacherId}`">历史直播列表 >></nuxt-link></p>
      </div>
      <div class="right title_right">
        <nuxt-link v-if="data.isLive" :to="`/room/${data.roomId}`">今日直播进行中 >></nuxt-link>
        <div v-else>今日未开播</div>
      </div>
    </div>
    <div class="content_wrap main yf-text_12 clearfix">
      <div class="content-left left">
        <div class="content_top clearfix">
          <div class="title left">{{ data.createdAt }} 直播主题：{{ data.topicName }}</div>
          <p class="number right">参与用户<span>{{ data.totalOnline }}</span>人</p>
        </div>
        <!-- 直播组件 -->
        <div v-if="t === 'main'" ref="live" class="content content_datail room_live">
          <y-room-live :data="item" :key="index" v-for="(item, index) in messageData"></y-room-live>
        </div>
        <!-- 付费观点组件 -->
        <div v-else-if="t === 'encrypted-view'" class="content content_datail view-live">
          <!-- 消息组件 -->
          <y-room-encrypted-view :key="item.id" :data="item" v-for="item in encryptedViewData"></y-room-encrypted-view>
        </div>

        <!-- 底部导航 -->
        <div class="bottom_nume_left left">
          <div class="roomnav">
            <nuxt-link :class="{active: t === 'main'}" :to="`/room/history/${data.id}`">
              直播
            </nuxt-link>
            <nuxt-link :class="{active: t === 'encrypted-view'}" :to="`/room/history/${data.id}?t=encrypted-view`">
              加密观点
            </nuxt-link>
            <nuxt-link :to="`/article/list/${data.teacherId}`">
              文章
              <img v-show="!isRoomTeacher && articleCount > 0" src="~assets/order-icon.png" alt="文章" />
            </nuxt-link>
            <nuxt-link :to="`/vip/detail/${data.teacherId}`" v-if="trainingId">
              特训班
              <img v-show="!isRoomTeacher && vipCount" src="~assets/order-icon.png" alt="特训班" />
            </nuxt-link>
            <span @click="showTip" v-else>特训班</span>
            <nuxt-link :to="`/question/list/${data.teacherId}`">
              问答
            </nuxt-link>
          </div>
        </div>
        <!-- 底部导航 over -->
      </div>
      <div class="content-right right">
        <div class="content_top clearfix">
          <p class="left">同学互动</p>
          <p class="right">字体
            <span :class="{active: fontSize === '18'}" @click="fontSize = '18'">大</span>
            <span :class="{active: fontSize === '16'}" @click="fontSize = '16'">中</span>
            <span :class="{active: fontSize === '14'}" @click="fontSize = '14'">小</span>
          </p>
        </div>
        <div ref="chat" class="content content_datail">
          <!-- 评论组件 -->
          <y-room-chat :fontSize="fontSize" :data="item" :key="index" v-for="(item, index) in commentData" :font-size="fontSize"></y-room-chat>
        </div>
      </div>
    </div>
    <y-elite-introduce></y-elite-introduce>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Dialog from '@/utils/Dialog'
import YRoomChat from '@/components/room/Chat'
import YRoomLive from '@/components/room/Live'
import YRoomEncryptedView from '@/components/room/EncryptedView'
import YEliteIntroduce from '@/components/room/EliteIntroduce'

export default {
  name: 'room-history',
  scrollToTop: true,
  validate ({ params }) {
    return params.id > 0
  },
  async asyncData ({ params, query, store, redirect, error, $axios }) {
    // 获取历史直播数据
    let history = await $axios._get('/History/Topic', { id: params.id })

    if (!history) {
      error({ statusCode: 404, message: '该页面不存在' })
      return
    }
    if (history.teacherId > 0) {
      // 初始化老师数据
      await store.dispatch('teacher/getInfo', history.teacherId)
    }
    return {
      data: history
    }
  },
  head () {
    return {
      title: `${this.data.topicName}_${this.data.teacherName}:${this.data.teacherName}直播室_历史直播_一富财经直播室_一富财经`
    }
  },
  data () {
    return {
      fontSize: null,
      page: [1, 1],
      isLoading: [true, true]
    }
  },
  mounted () {
    // 获取右侧消息字体大小
    this.fontSize = this.$cookies.get('yf_room_chat_font') || '16'
    // 获取初始消息数据
    this.loadData(0)
    this.loadData(1)
    this.$refs.live.addEventListener('scroll', this.listener)
    this.$refs.chat.addEventListener('scroll', this.listener)

    // 获取付费观点数据
    this.$store.dispatch('room/initEncryptedViewList', this.$route.params.id)

    // 初始可售卖产品
    this.$store.dispatch('teacher/getGoods', this.data.teacherId)

    // 广告位数据
    this.$store.dispatch('getAd', ['roomTopImageNormal', 'roomBottomImageNormal', 'roomTopLeftNormal'])
  },
  methods:{
    listener (e) {
      if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 100) {
        let type = e.target.classList.contains('room_live') ? 0 : 1
        if (this.isLoading[type]) {
          this.loadData(type)
        }
      }
    },
    loadData (type) {
      this.isLoading[type] = false
      let payload = {
        id: this.$route.params.id,
        page: this.page[type],
        type,
        num: 20,
        history: true
      }
      this.$store.dispatch('room/initHistoryList', payload).then(res => {
        if (res.totalCount === 0 || this[`${type ? 'comment' : 'message'}Data`].length === res.totalCount) {
          let el = type ? this.$refs.chat : this.$refs.live
          el.removeEventListener('scroll', this.listener)
        }
        this.page[type]++
        this.isLoading[type] = true
      })
    },
    toBottom (type) {
      this.$nextTick(() => {
        this.$refs[type].scrollTop = this.$refs[type].scrollHeight
      })
    },
    showTip () {
      if (this.isRoomTeacher) {
        Dialog.alert('您尚未创建特训班，是否前去创建？', {
          showCancelButton: true
        }).then(() => {
          this.$router.push('/vip/edit')
        })
      } else {
        Dialog.alert('老师尚未创建特训班')
      }
    }
  },
  computed: {
    t () {
      return this.$route.query.t || 'main'
    },
    ...mapState({
      authUser: state => state.user.data,
      messageData: state => state.room.messageList,
      commentData: state => state.room.commentList,
      encryptedViewData: state => state.room.encryptedViewList,
      articleCount: state => state.teacher.saleArticle.length,
      vipCount: state => !!state.teacher.saleVip,
      encryptedViewCount: state => state.room.encryptedViewList.length,
      trainingId: state => state.teacher.data.trainingId
    }),
    isRoomTeacher () {
      return this.authUser && this.authUser.id === this.data.teacherId
    }
  },
  watch: {
    fontSize (n) {
      n === '16' ? this.$cookies.remove('yf_room_chat_font') : this.$cookies.set('yf_room_chat_font', n, 2000)
    }
  },
  components:{
    YRoomChat,
    YRoomLive,
    YRoomEncryptedView,
    YEliteIntroduce
  }
}
</script>
